import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('orders' + params)
	},
	remove(order_id) {
		return http.delete('orders/' + order_id)
	},
	flow(params = '') {
		return http.get('orders/flow' + params)
	},
	options(params = '') {
		return http.get('orders/options' + params)
	},
	createOrUpdate(data) {
		if(data.id) {
			return http.put('orders/' + data.id, data)
		} else {
			return http.post('orders', data)
		}
	},
	transferencia(data) {
		return http.post('orders/transferencias', data)
	},
	pay(order) {
		return http.put('orders/' + order.id + '/pay')
	},
	show(id) {
		return http.get('orders/' + id)
	},
	getBadgeClass(item) {
		switch(item.status) {
			case 'AGUARDANDO':
				return 'badge-aguardando'

			case 'APROVADO':
				return 'badge-aprovado';

			case 'RECUSADO':
				return 'badge-recusado';

			case 'ENTREGUE':
				return 'badge-entregue';
		}
	},
	
	isExpense(order) {
		if(order.type == 'e') {
			return true
		}

		return false;
	},

	isRevenue(order) {
		if(order.type == 'r') {
			return true
		}

		return false;
	},
}